<script setup lang="ts">
import { BellIcon } from '@heroicons/vue/20/solid';
import {
  ArrowTopRightOnSquareIcon,
  QuestionMarkCircleIcon,
} from '@heroicons/vue/20/solid';
import AccountMenu from 'src/components/Account/AccountMenu.vue';
import ContextCard from 'src/components/common/ContextCard.vue';
import UserAvatar from 'src/components/common/UserAvatar.vue';
import { APP_LINKS } from 'src/core/AppConstants';
</script>
<template>
  <div class="fixed left-0 right-0">
    <div class="navbar hidden justify-end bg-base-100 px-4 md:flex">
      <div class="indicator">
        <span
          class="badge indicator-item badge-secondary -translate-y-1/2 translate-x-1/3 scale-50 transform"
        ></span>
        <button
          type="button"
          class="tooltip tooltip-bottom"
          data-tip="What's new"
          onclick="an_modal_whats_new.showModal()"
        >
          <BellIcon class="w-6 text-slate-600 hover:text-slate-900" />
        </button>
      </div>
      <div class="tooltip tooltip-bottom ml-2" data-tip="Help">
        <ContextCard class="w-full" position="right" margin="-mt-1 ml-4 z-50">
          <div
            class="user-wrapper flex w-full cursor-pointer items-center justify-center"
          >
            <QuestionMarkCircleIcon
              class="w-6 text-slate-600 hover:text-slate-900"
            />
          </div>
          <template #content>
            <div class="overflow-hidden">
              <a
                :href="APP_LINKS.GOOGLE_FORMS_FEEDBACK"
                rel="noopener"
                target="_blank"
                class="flex items-center text-nowrap px-4 py-2 hover:bg-slate-100"
              >
                Send feedback to AthleticNext
                <ArrowTopRightOnSquareIcon class="ml-1 w-4" />
              </a>
            </div>
          </template>
        </ContextCard>
      </div>
      <div class="ml-2">
        <ContextCard class="w-full" position="right" margin="-mt-1 ml-4 z-50">
          <div
            class="user-wrapper flex w-full cursor-pointer items-center justify-center"
          >
            <UserAvatar />
          </div>
          <template #content>
            <AccountMenu class="w-64" />
          </template>
        </ContextCard>
      </div>
    </div>
  </div>
</template>
